import { Link, useLoaderData } from "react-router-dom";
import * as API from "../services/psqi";

import { calculatePsqiResults } from "./PsqiCalc";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getPsqiByID(params.psqiId);
}

export function PsqiItem(props) {
  const psqi = useLoaderData();
  const errorMessage = psqi.message;

  const psqiResp = psqi.meta?.psqiResp;
  const metaFecha = psqi.meta?.metaFecha;
  const psqiPreg001 = psqi.meta?.psqiPreg001;
  const psqiPreg002 = psqi.meta?.psqiPreg002;
  const psqiPreg003 = psqi.meta?.psqiPreg003;
  const psqiPreg004 = psqi.meta?.psqiPreg004;
  const psqiPreg005a = psqi.meta?.psqiPreg005a;
  const psqiPreg005b = psqi.meta?.psqiPreg005b;
  const psqiPreg005c = psqi.meta?.psqiPreg005c;
  const psqiPreg005d = psqi.meta?.psqiPreg005d;
  const psqiPreg005e = psqi.meta?.psqiPreg005e;
  const psqiPreg005f = psqi.meta?.psqiPreg005f;
  const psqiPreg005g = psqi.meta?.psqiPreg005g;
  const psqiPreg005h = psqi.meta?.psqiPreg005h;
  const psqiPreg005i = psqi.meta?.psqiPreg005i;
  const psqiPreg005j = psqi.meta?.psqiPreg005j;
  const psqiPreg005k = psqi.meta?.psqiPreg005k;
  const psqiPreg006 = psqi.meta?.psqiPreg006;
  const psqiPreg007 = psqi.meta?.psqiPreg007;
  const psqiPreg008 = psqi.meta?.psqiPreg008;
  const psqiPreg009 = psqi.meta?.psqiPreg009;
  const psqiPreg010 = psqi.meta?.psqiPreg010;
  const psqiPreg010a = psqi.meta?.psqiPreg010a;
  const psqiPreg010b = psqi.meta?.psqiPreg010b;
  const psqiPreg010c = psqi.meta?.psqiPreg010c;
  const psqiPreg010d = psqi.meta?.psqiPreg010d;
  const psqiPreg010e = psqi.meta?.psqiPreg010e;
  const psqiPreg010f = psqi.meta?.psqiPreg010f;

  const psqiDate = new Date(psqi.date);
  const diffDate = Math.abs(new Date() - psqiDate) / 36e5;

  // comprobar si es un número
  const isValidNumber = (value) =>
    value != null && value !== "" && !isNaN(value);

   // Obtener resultados calculados
   const psqiResults = calculatePsqiResults(psqi.meta);
 
   // Asignar variables con nombres específicos
   const totalSumComp1 = psqiResults.calidadDelSueno;
   const totalSumComp2 = psqiResults.latenciaDelSueno;
   const totalSumComp3 = psqiResults.duraciónDelSueno;
   const totalSumComp4 = psqiResults.eficienciaDelSueno;
   const totalSumComp5 = psqiResults.despertaresNocturnos;
   const totalSumComp6 = psqiResults.usoDeMedicamentos;
   const totalSumComp7 = psqiResults.disfunciónDiurna;
   const totalSumCompT = psqiResults.puntuacionGlobal;

  // resultados cuestionario cards

  const createResultProperties = (result, low, high) => {
    // Convertir los strings que vienen del meta a numbers
    result = parseFloat(result);
    low = parseFloat(low);
    high = parseFloat(high);
    const color =
      result >= low && result <= high
        ? "anali-result-good"
        : "anali-result-bad";
    const markIn = Math.min(
      Math.max(((result - low) / (high - low)) * 100, 0),
      100
    ).toFixed(0);
    const markOut =
      result < low
        ? "anali-result-low"
        : result > high
        ? "anali-result-high"
        : "";
    return { color, markIn, markOut };
  };

  // Graphics

  const limits = {
    compT: { low: 0, high: 21 },
    comp1: { low: 0, high: 3 },
    comp2: { low: 0, high: 3 },
    comp3: { low: 0, high: 3 },
    comp4: { low: 0, high: 3 },
    comp5: { low: 0, high: 3 },
    comp6: { low: 0, high: 3 },
    comp7: { low: 0, high: 3 },
  };

  const {
    color: sumCompTColor,
    markIn: sumCompTMarkIn,
    markOut: sumCompTMarkOut,
  } = createResultProperties(totalSumCompT, limits.compT.low, limits.compT.high);

  const {
    color: sumComp1Color,
    markIn: sumComp1MarkIn,
    markOut: sumComp1MarkOut,
  } = createResultProperties(totalSumComp1, limits.comp1.low, limits.comp1.high);
  
  const {
    color: sumComp2Color,
    markIn: sumComp2MarkIn,
    markOut: sumComp2MarkOut,
  } = createResultProperties(totalSumComp2, limits.comp2.low, limits.comp2.high);
  
  const {
    color: sumComp3Color,
    markIn: sumComp3MarkIn,
    markOut: sumComp3MarkOut,
  } = createResultProperties(totalSumComp3, limits.comp3.low, limits.comp3.high);
  
  const {
    color: sumComp4Color,
    markIn: sumComp4MarkIn,
    markOut: sumComp4MarkOut,
  } = createResultProperties(totalSumComp4, limits.comp4.low, limits.comp4.high);
  
  const {
    color: sumComp5Color,
    markIn: sumComp5MarkIn,
    markOut: sumComp5MarkOut,
  } = createResultProperties(totalSumComp5, limits.comp5.low, limits.comp5.high);
  
  const {
    color: sumComp6Color,
    markIn: sumComp6MarkIn,
    markOut: sumComp6MarkOut,
  } = createResultProperties(totalSumComp6, limits.comp6.low, limits.comp6.high);
  
  const {
    color: sumComp7Color,
    markIn: sumComp7MarkIn,
    markOut: sumComp7MarkOut,
  } = createResultProperties(totalSumComp7, limits.comp7.low, limits.comp7.high);

  return (
    <>
      <div id="content">
        {psqi.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <>
            <form id="formUpdatelement" className="newRadioButtons">
              <fieldset id="disabledContainer" disabled="disabled">
                <div className="grid--2col">
                  <div className="field">
                    <label htmlFor="psqiResp">Responsable</label>
                    <div className="control">
                      <input
                        className="input"
                        id="psqiResp"
                        required
                        type="text"
                        value={psqiResp}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="metaFecha">Fecha visita</label>
                    <div className="control">
                      <input
                        className="input"
                        id="metaFecha"
                        required
                        type="date"
                        value={metaFecha}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <h3>Cuestionario PSQI</h3>
                <p>Ayúdanos a optimizar tu tratamiento y observa tu evolución. Completa el cuestionario y OBTÉN 10€ A CAMBIO.</p>
                <br></br>
                <p>Las siguientes preguntas se refieren a tus HÁBITOS DE SUEÑO sólo durante el mes pasado. Tus respuestas deben reflejar la contestación más acertada para la mayoría de días y noches DURANTE LOS ÚLTIMOS 30 DÍAS. Por favor, contesta a todas las preguntas.</p>
                <br></br>

                <div className="grid--2col">
                  <div className="field">
                    <label htmlFor="psqiPreg001">
                      1. Durante el mes pasado, ¿a qué hora se ha ido a la cama
                      habitualmente de noche?
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        id="psqiPreg001"
                        required
                        type="time"
                        value={psqiPreg001}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="psqiPreg002">
                      2. Durante el mes pasado, ¿cuánto tiempo (en minutos) ha
                      tardado en dormirse habitualmente?
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        id="psqiPreg002"
                        required
                        type="number"
                        value={psqiPreg002}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="psqiPreg003">
                      3. Durante el mes pasado, ¿a qué hora se ha levantado
                      habitualmente por la mañana?
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        id="psqiPreg003"
                        required
                        type="time"
                        value={psqiPreg003}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="psqiPreg004">
                      4. Durante el mes pasado, ¿cuántas horas calcula que habrá
                      dormido por la noche?
                    </label>
                    <div className="control">
                      <input
                        className="input"
                        id="psqiPreg004"
                        required
                        type="number"
                        value={psqiPreg004}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <p>
                  5. Durante el mes pasado, cuántas veces ha tenido Vd.
                  problemas para dormir a causa de...
                </p>

                <div className="form-radio-container">
                  <div className="grid--2-col">
                    <div className="radio-capt radio--4-col">
                      <p>No durante el mes pasado</p>
                      <p>Menos de una vez a la semana</p>
                      <p>Una o dos veces a la semana</p>
                      <p>Tres o más veces a la semana</p>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005a">
                        a. no poder conciliar el sueño en 30 minutos
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005a-0">
                          <input
                            id="psqiPreg005a-0"
                            name="psqiPreg005a"
                            type="radio"
                            value="0"
                            checked={psqiPreg005a === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005a-1">
                          <input
                            id="psqiPreg005a-1"
                            name="psqiPreg005a"
                            type="radio"
                            value="1"
                            checked={psqiPreg005a === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005a-2">
                          <input
                            id="psqiPreg005a-2"
                            name="psqiPreg005a"
                            type="radio"
                            value="2"
                            checked={psqiPreg005a === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005a-3">
                          <input
                            id="psqiPreg005a-3"
                            name="psqiPreg005a"
                            type="radio"
                            value="3"
                            checked={psqiPreg005a === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005b">
                        b. despertarme en mitad de la noche o de madrugada
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005b-0">
                          <input
                            id="psqiPreg005b-0"
                            name="psqiPreg005b"
                            type="radio"
                            value="0"
                            checked={psqiPreg005b === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005b-1">
                          <input
                            id="psqiPreg005b-1"
                            name="psqiPreg005b"
                            type="radio"
                            value="1"
                            checked={psqiPreg005b === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005b-2">
                          <input
                            id="psqiPreg005b-2"
                            name="psqiPreg005b"
                            type="radio"
                            value="2"
                            checked={psqiPreg005b === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005b-3">
                          <input
                            id="psqiPreg005b-3"
                            name="psqiPreg005b"
                            type="radio"
                            value="3"
                            checked={psqiPreg005b === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005c">
                        c. tener que levantarme para ir al servicio
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005c-0">
                          <input
                            id="psqiPreg005c-0"
                            name="psqiPreg005c"
                            type="radio"
                            value="0"
                            checked={psqiPreg005c === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005c-1">
                          <input
                            id="psqiPreg005c-1"
                            name="psqiPreg005c"
                            type="radio"
                            value="1"
                            checked={psqiPreg005c === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005c-2">
                          <input
                            id="psqiPreg005c-2"
                            name="psqiPreg005c"
                            type="radio"
                            value="2"
                            checked={psqiPreg005c === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005c-3">
                          <input
                            id="psqiPreg005c-3"
                            name="psqiPreg005c"
                            type="radio"
                            value="3"
                            checked={psqiPreg005c === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005d">
                        d. no poder respirar bien
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005d-0">
                          <input
                            id="psqiPreg005d-0"
                            name="psqiPreg005d"
                            type="radio"
                            value="0"
                            checked={psqiPreg005d === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005d-1">
                          <input
                            id="psqiPreg005d-1"
                            name="psqiPreg005d"
                            type="radio"
                            value="1"
                            checked={psqiPreg005d === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005d-2">
                          <input
                            id="psqiPreg005d-2"
                            name="psqiPreg005d"
                            type="radio"
                            value="2"
                            checked={psqiPreg005d === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005d-3">
                          <input
                            id="psqiPreg005d-3"
                            name="psqiPreg005d"
                            type="radio"
                            value="3"
                            checked={psqiPreg005d === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005e">
                        e. toser o roncar fuertemente
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005e-0">
                          <input
                            id="psqiPreg005e-0"
                            name="psqiPreg005e"
                            type="radio"
                            value="0"
                            checked={psqiPreg005e === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005e-1">
                          <input
                            id="psqiPreg005e-1"
                            name="psqiPreg005e"
                            type="radio"
                            value="1"
                            checked={psqiPreg005e === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005e-2">
                          <input
                            id="psqiPreg005e-2"
                            name="psqiPreg005e"
                            type="radio"
                            value="2"
                            checked={psqiPreg005e === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005e-3">
                          <input
                            id="psqiPreg005e-3"
                            name="psqiPreg005e"
                            type="radio"
                            value="3"
                            checked={psqiPreg005e === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005f">
                        f. sentir demasiado frío
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005f-0">
                          <input
                            id="psqiPreg005f-0"
                            name="psqiPreg005f"
                            type="radio"
                            value="0"
                            checked={psqiPreg005f === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005f-1">
                          <input
                            id="psqiPreg005f-1"
                            name="psqiPreg005f"
                            type="radio"
                            value="1"
                            checked={psqiPreg005f === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005f-2">
                          <input
                            id="psqiPreg005f-2"
                            name="psqiPreg005f"
                            type="radio"
                            value="2"
                            checked={psqiPreg005f === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005f-3">
                          <input
                            id="psqiPreg005f-3"
                            name="psqiPreg005f"
                            type="radio"
                            value="3"
                            checked={psqiPreg005f === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005g">
                        g. sentir demasiado calor
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005g-0">
                          <input
                            id="psqiPreg005g-0"
                            name="psqiPreg005g"
                            type="radio"
                            value="0"
                            checked={psqiPreg005g === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005g-1">
                          <input
                            id="psqiPreg005g-1"
                            name="psqiPreg005g"
                            type="radio"
                            value="1"
                            checked={psqiPreg005g === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005g-2">
                          <input
                            id="psqiPreg005g-2"
                            name="psqiPreg005g"
                            type="radio"
                            value="2"
                            checked={psqiPreg005g === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005g-3">
                          <input
                            id="psqiPreg005g-3"
                            name="psqiPreg005g"
                            type="radio"
                            value="3"
                            checked={psqiPreg005g === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005h">
                        h. tener malos sueños
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005h-0">
                          <input
                            id="psqiPreg005h-0"
                            name="psqiPreg005h"
                            type="radio"
                            value="0"
                            checked={psqiPreg005h === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005h-1">
                          <input
                            id="psqiPreg005h-1"
                            name="psqiPreg005h"
                            type="radio"
                            value="1"
                            checked={psqiPreg005h === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005h-2">
                          <input
                            id="psqiPreg005h-2"
                            name="psqiPreg005h"
                            type="radio"
                            value="2"
                            checked={psqiPreg005h === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005h-3">
                          <input
                            id="psqiPreg005h-3"
                            name="psqiPreg005h"
                            type="radio"
                            value="3"
                            checked={psqiPreg005h === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005i">
                        i. tener dolor
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005i-0">
                          <input
                            id="psqiPreg005i-0"
                            name="psqiPreg005i"
                            type="radio"
                            value="0"
                            checked={psqiPreg005i === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005i-1">
                          <input
                            id="psqiPreg005i-1"
                            name="psqiPreg005i"
                            type="radio"
                            value="1"
                            checked={psqiPreg005i === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005i-2">
                          <input
                            id="psqiPreg005i-2"
                            name="psqiPreg005i"
                            type="radio"
                            value="2"
                            checked={psqiPreg005i === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005i-3">
                          <input
                            id="psqiPreg005i-3"
                            name="psqiPreg005i"
                            type="radio"
                            value="3"
                            checked={psqiPreg005i === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="field exception-bg">
                    <div className="control grid--2col">
                      <label htmlFor="psqiPreg005j">
                        j. Otra razón (es), por favor descríbela (s)
                      </label>
                      <input
                        className="input"
                        type="text"
                        name="psqiPreg005j"
                        id="psqiPreg005j"
                        value={psqiPreg005j}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="field force-bg">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg005k">
                        Durante el mes pasado, ¿con qué frecuencia ha tenido
                        problemas de sueño a causa de esto?
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg005k-0">
                          <input
                            id="psqiPreg005k-0"
                            name="psqiPreg005k"
                            type="radio"
                            value="0"
                            checked={psqiPreg005k === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg005k-1">
                          <input
                            id="psqiPreg005k-1"
                            name="psqiPreg005k"
                            type="radio"
                            value="1"
                            checked={psqiPreg005k === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg005k-2">
                          <input
                            id="psqiPreg005k-2"
                            name="psqiPreg005k"
                            type="radio"
                            value="2"
                            checked={psqiPreg005k === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg005k-3">
                          <input
                            id="psqiPreg005k-3"
                            name="psqiPreg005k"
                            type="radio"
                            value="3"
                            checked={psqiPreg005k === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-radio-container">
                  <div className="grid--2-col">
                    <div className="radio-capt radio--4-col">
                      <p>Muy buena</p>
                      <p>Buena</p>
                      <p>Mala</p>
                      <p>Muy mala</p>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg006">
                        6. Durante el mes pasado, ¿cómo valoraría, en conjunto,
                        la calidad de su sueño?
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg006-0">
                          <input
                            id="psqiPreg006-0"
                            name="psqiPreg006"
                            type="radio"
                            value="0"
                            checked={psqiPreg006 === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg006-1">
                          <input
                            id="psqiPreg006-1"
                            name="psqiPreg006"
                            type="radio"
                            value="1"
                            checked={psqiPreg006 === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg006-2">
                          <input
                            id="psqiPreg006-2"
                            name="psqiPreg006"
                            type="radio"
                            value="2"
                            checked={psqiPreg006 === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg006-3">
                          <input
                            id="psqiPreg006-3"
                            name="psqiPreg006"
                            type="radio"
                            value="3"
                            checked={psqiPreg006 === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-radio-container">
                  <div className="grid--2-col">
                    <div className="radio-capt radio--4-col">
                      <p>No durante el mes pasado</p>
                      <p>Menos de una vez a la semana </p>
                      <p>Una o dos veces a la semana </p>
                      <p>Tres o más veces a la semana</p>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg007">
                        7. Durante el mes pasado, ¿cuántas veces ha tomado
                        medicación (prescrita o de "parafarmacia") para dormir?
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg007-0">
                          <input
                            id="psqiPreg007-0"
                            name="psqiPreg007"
                            type="radio"
                            value="0"
                            checked={psqiPreg007 === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg007-1">
                          <input
                            id="psqiPreg007-1"
                            name="psqiPreg007"
                            type="radio"
                            value="1"
                            checked={psqiPreg007 === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg007-2">
                          <input
                            id="psqiPreg007-2"
                            name="psqiPreg007"
                            type="radio"
                            value="2"
                            checked={psqiPreg007 === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg007-3">
                          <input
                            id="psqiPreg007-3"
                            name="psqiPreg007"
                            type="radio"
                            value="3"
                            checked={psqiPreg007 === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg008">
                        8. Durante el mes pasado, ¿cuántas veces ha tenido
                        problemas para mantenerse despierto mientras conducía,
                        comía, o mantenía una actividad social?
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg008-0">
                          <input
                            id="psqiPreg008-0"
                            name="psqiPreg008"
                            type="radio"
                            value="0"
                            checked={psqiPreg008 === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg008-1">
                          <input
                            id="psqiPreg008-1"
                            name="psqiPreg008"
                            type="radio"
                            value="1"
                            checked={psqiPreg008 === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg008-2">
                          <input
                            id="psqiPreg008-2"
                            name="psqiPreg008"
                            type="radio"
                            value="2"
                            checked={psqiPreg008 === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg008-3">
                          <input
                            id="psqiPreg008-3"
                            name="psqiPreg008"
                            type="radio"
                            value="3"
                            checked={psqiPreg008 === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-radio-container">
                  <div className="grid--2-col">
                    <div className="radio-capt radio--4-col">
                      <p>Ningún problema</p>
                      <p>Sólo un ligero problema</p>
                      <p>Algo de problema</p>
                      <p>Un grave problema</p>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg009">
                        9. Durante el mes pasado, ¿en qué medida ha sido un
                        problema mantener el ánimo para hacer lo que tenía que
                        hacer?
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg009-0">
                          <input
                            id="psqiPreg009-0"
                            name="psqiPreg009"
                            type="radio"
                            value="0"
                            checked={psqiPreg009 === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg009-1">
                          <input
                            id="psqiPreg009-1"
                            name="psqiPreg009"
                            type="radio"
                            value="1"
                            checked={psqiPreg009 === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg009-2">
                          <input
                            id="psqiPreg009-2"
                            name="psqiPreg009"
                            type="radio"
                            value="2"
                            checked={psqiPreg009 === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg009-3">
                          <input
                            id="psqiPreg009-3"
                            name="psqiPreg009"
                            type="radio"
                            value="3"
                            checked={psqiPreg009 === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-radio-container">
                  <div className="grid--2-col">
                    <div className="radio-capt radio--4-col">
                      <p>No pareja o compañero de habitación</p>
                      <p>Pareja/ compañero en otra habitación</p>
                      <p>Pareja en misma habitación pero no misma cama</p>
                      <p>Pareja en la misma cama</p>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg010">
                        10. ¿Tiene pareja o compañero de habitación?
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg010-0">
                          <input
                            id="psqiPreg010-0"
                            name="psqiPreg010"
                            type="radio"
                            value="0"
                            checked={psqiPreg010 === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg010-1">
                          <input
                            id="psqiPreg010-1"
                            name="psqiPreg010"
                            type="radio"
                            value="1"
                            checked={psqiPreg010 === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg010-2">
                          <input
                            id="psqiPreg010-2"
                            name="psqiPreg010"
                            type="radio"
                            value="2"
                            checked={psqiPreg010 === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg010-3">
                          <input
                            id="psqiPreg010-3"
                            name="psqiPreg010"
                            type="radio"
                            value="3"
                            checked={psqiPreg010 === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <p>
                  Si tiene pareja o compañero de habitación, pregúntele si
                  durante el mes pasado Vd. ha tenido...
                </p>

                <div className="form-radio-container">
                  <div className="grid--2-col">
                    <div className="radio-capt radio--4-col">
                      <p>No durante el mes pasado</p>
                      <p>Menos de una vez a la semana</p>
                      <p>Una o dos veces a la semana</p>
                      <p>Tres o más veces a la semana</p>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg010a">
                        a. ronquidos fuertes
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg010a-0">
                          <input
                            id="psqiPreg010a-0"
                            name="psqiPreg010a"
                            type="radio"
                            value="0"
                            checked={psqiPreg010a === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg010a-1">
                          <input
                            id="psqiPreg010a-1"
                            name="psqiPreg010a"
                            type="radio"
                            value="1"
                            checked={psqiPreg010a === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg010a-2">
                          <input
                            id="psqiPreg010a-2"
                            name="psqiPreg010a"
                            type="radio"
                            value="2"
                            checked={psqiPreg010a === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg010a-3">
                          <input
                            id="psqiPreg010a-3"
                            name="psqiPreg010a"
                            type="radio"
                            value="3"
                            checked={psqiPreg010a === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg010b">
                        b. grandes pausas entre respiraciones mientras duerme
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg010b-0">
                          <input
                            id="psqiPreg010b-0"
                            name="psqiPreg010b"
                            type="radio"
                            value="0"
                            checked={psqiPreg010b === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg010b-1">
                          <input
                            id="psqiPreg010b-1"
                            name="psqiPreg010b"
                            type="radio"
                            value="1"
                            checked={psqiPreg010b === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg010b-2">
                          <input
                            id="psqiPreg010b-2"
                            name="psqiPreg010b"
                            type="radio"
                            value="2"
                            checked={psqiPreg010b === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg010b-3">
                          <input
                            id="psqiPreg010b-3"
                            name="psqiPreg010b"
                            type="radio"
                            value="3"
                            checked={psqiPreg010b === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg010c">
                        c. contracciones o sacudidas de piernas mientras duerme
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg010c-0">
                          <input
                            id="psqiPreg010c-0"
                            name="psqiPreg010c"
                            type="radio"
                            value="0"
                            checked={psqiPreg010c === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg010c-1">
                          <input
                            id="psqiPreg010c-1"
                            name="psqiPreg010c"
                            type="radio"
                            value="1"
                            checked={psqiPreg010c === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg010c-2">
                          <input
                            id="psqiPreg010c-2"
                            name="psqiPreg010c"
                            type="radio"
                            value="2"
                            checked={psqiPreg010c === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg010c-3">
                          <input
                            id="psqiPreg010c-3"
                            name="psqiPreg010c"
                            type="radio"
                            value="3"
                            checked={psqiPreg010c === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg010d">
                        d. episodios de desorientación o confusión mientras
                        duerme
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg010d-0">
                          <input
                            id="psqiPreg010d-0"
                            name="psqiPreg010d"
                            type="radio"
                            value="0"
                            checked={psqiPreg010d === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg010d-1">
                          <input
                            id="psqiPreg010d-1"
                            name="psqiPreg010d"
                            type="radio"
                            value="1"
                            checked={psqiPreg010d === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg010d-2">
                          <input
                            id="psqiPreg010d-2"
                            name="psqiPreg010d"
                            type="radio"
                            value="2"
                            checked={psqiPreg010d === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg010d-3">
                          <input
                            id="psqiPreg010d-3"
                            name="psqiPreg010d"
                            type="radio"
                            value="3"
                            checked={psqiPreg010d === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="field exception-bg">
                    <div className="control grid--2col">
                      <label htmlFor="psqiPreg010e">
                        e. Otra razón (es), por favor descríbela (s)
                      </label>
                      <input
                        className="input"
                        type="text"
                        name="psqiPreg010e"
                        id="psqiPreg010e"
                        value={psqiPreg010e}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="field exception-bg">
                    <div className="control grid--2col">
                      <label className="radio-title" htmlFor="psqiPreg010f">
                        Durante el mes pasado, ¿con qué frecuencia ha tenido
                        problemas de sueño a causa de esto?
                      </label>
                      <div className="radio--4-col">
                        <label className="radio" htmlFor="psqiPreg010f-0">
                          <input
                            id="psqiPreg010f-0"
                            name="psqiPreg010f"
                            type="radio"
                            value="0"
                            checked={psqiPreg010f === "0"}
                            readOnly
                          />
                          0
                        </label>
                        <label className="radio" htmlFor="psqiPreg010f-1">
                          <input
                            id="psqiPreg010f-1"
                            name="psqiPreg010f"
                            type="radio"
                            value="1"
                            checked={psqiPreg010f === "1"}
                            readOnly
                          />
                          1
                        </label>
                        <label className="radio" htmlFor="psqiPreg010f-2">
                          <input
                            id="psqiPreg010f-2"
                            name="psqiPreg010f"
                            type="radio"
                            value="2"
                            checked={psqiPreg010f === "2"}
                            readOnly
                          />
                          2
                        </label>
                        <label className="radio" htmlFor="psqiPreg010f-3">
                          <input
                            id="psqiPreg010f-3"
                            name="psqiPreg010f"
                            type="radio"
                            value="3"
                            checked={psqiPreg010f === "3"}
                            readOnly
                          />
                          3
                        </label>
                      </div>
                    </div>
                  </div>
                  
                </div>

                <div className="analitic-form form-results from-results-new form-results-psqi">
                  <h3>Resultados de la autoevaluación PSQI</h3>
                  <div className="three-col-analitic">

                  {/* Componente 0: Puntuación Global PSQI */}
                <div className="anali-el">
                  <p className="anali-title">Puntuación Global PSQI</p>
                  {totalSumCompT !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumCompTColor}`}>
                        {totalSumCompT}
                      </p>
                      <div className={`anali-bar-full ${sumCompTMarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumCompTMarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.compT.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.compT.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 1: Calidad subjetiva del sueño */}
                <div className="anali-el">
                  <p className="anali-title">Calidad subjetiva del sueño</p>
                  {totalSumComp1 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp1Color}`}>
                        {totalSumComp1}
                      </p>
                      <div className={`anali-bar-full ${sumComp1MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp1MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp1.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp1.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 2: Latencia de sueño */}
                <div className="anali-el">
                  <p className="anali-title">Latencia de sueño</p>
                  {totalSumComp2 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp2Color}`}>
                        {totalSumComp2}
                      </p>
                      <div className={`anali-bar-full ${sumComp2MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp2MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp2.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp2.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 3: Duración del sueño */}
                <div className="anali-el">
                  <p className="anali-title">Duración del sueño</p>
                  {totalSumComp3 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp3Color}`}>
                        {totalSumComp3}
                      </p>
                      <div className={`anali-bar-full ${sumComp3MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp3MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp3.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp3.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 4: Eficiencia habitual del sueño */}
                <div className="anali-el">
                  <p className="anali-title">Eficiencia habitual del sueño</p>
                  {totalSumComp4 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp4Color}`}>
                        {totalSumComp4}
                      </p>
                      <div className={`anali-bar-full ${sumComp4MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp4MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp4.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp4.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 5: Alteraciones del sueño */}
                <div className="anali-el">
                  <p className="anali-title">Alteraciones del sueño</p>
                  {totalSumComp5 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp5Color}`}>
                        {totalSumComp5}
                      </p>
                      <div className={`anali-bar-full ${sumComp5MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp5MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp5.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp5.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 6: Uso de medicación para dormir */}
                <div className="anali-el">
                  <p className="anali-title">Uso de medicación para dormir</p>
                  {totalSumComp6 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp6Color}`}>
                        {totalSumComp6}
                      </p>
                      <div className={`anali-bar-full ${sumComp6MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp6MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp6.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp6.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 7: Disfunción diurna */}
                <div className="anali-el">
                  <p className="anali-title">Disfunción diurna</p>
                  {totalSumComp7 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp7Color}`}>
                        {totalSumComp7}
                      </p>
                      <div className={`anali-bar-full ${sumComp7MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp7MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp7.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp7.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                  
                </div>
                  
                </div>
              </fieldset>
            </form>
          </>
        )}
      </div>
      {!errorMessage && (
        <div id="actions">
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <Link className="button is-link" to={`edit`}>
              Editar
            </Link>
          )}
        </div>
      )}
    </>
  );
}
